import React from 'react';
import PropTypes from 'prop-types';

import AddEditModal from './AddEdit';

const ModalsManager = ({ access, open, item, error, available, isLoading, isLoadingSubmit, onHide, onSubmit, onDelete }) => (
  <>
    <AddEditModal
      open={open === 'add' || open === 'edit'}
      access={access}
      type={open}
      item={item}
      error={error}
      available={available}
      isLoading={isLoading}
      isLoadingSubmit={isLoadingSubmit}
      onHide={onHide}
      onSubmit={onSubmit}
      onDelete={onDelete}
    />
  </>
);

ModalsManager.propTypes = {
  access: PropTypes.object,
  open: PropTypes.string,
  item: PropTypes.object,
  error: PropTypes.string,
  available: PropTypes.array,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default ModalsManager;
